import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/dokumenty")({
  beforeLoad: requirePermissionGuard("hca.crm.read"),
});
